var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-notify-dialog',{attrs:{"show":_vm.notify.show,"success":_vm.notify.success,"msg":_vm.notify.msg,"title":_vm.notify.title},on:{"dialogClose":function($event){_vm.notify.show = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }